import React, { useEffect, useMemo, useState } from "react";
import { Modal, Form, Button } from "react-bootstrap";
import { allAPiServicesCall } from "../../services/apiServices";
import { getAuthConfig } from "../../services/apiUtils";
import { toast } from "react-toastify";
import MultiGenreSelect from "../common/MultiGenreSelect";

function SetTopAlbumPriorityModel({ show, handleClose, albumDetails, handleFormSubmit, genres = [] }) {
   console.log(albumDetails, "details")

  const [updatedData, setUpdatedData] = useState({
    priority: albumDetails.priority,
  });
  const [selectedGenres, setSelectedGenres] = useState([]);

  const normalizedGenres = useMemo(() => {
    const genreValue = albumDetails?.genre;
    if (!genreValue) return [];
    if (Array.isArray(genreValue)) return genreValue;
    return String(genreValue)
      .split(",")
      .map((genre) => genre.trim())
      .filter(Boolean);
  }, [albumDetails]);

  useEffect(() => {
    if (albumDetails) {
      setUpdatedData({ ...albumDetails });
      setSelectedGenres(normalizedGenres);
    }
  }, [albumDetails, normalizedGenres]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setUpdatedData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };


  const onSubmit = async (e) => {
    e.preventDefault();

    const finalUpdatedData = {
      priority: updatedData?.priority,
      album_id: albumDetails?.album_id,
      genre: selectedGenres.length > 0 ? selectedGenres.join(", ") : null,
      pageType: albumDetails?.pageType,
      genreSlug: albumDetails?.genreSlug,
    };
 
    try {
      const updateResponse = await allAPiServicesCall.patchUpdateTopAlbumPriority(
        finalUpdatedData,
        getAuthConfig()
      );
      console.log(updateResponse,"updateresponse");

      if (updateResponse && updateResponse.success) {
        toast.success("Top Album updated successfully");
        handleFormSubmit?.();
        handleClose();
      } else {
        toast.error("Failed to update Top Album");
      }
    } catch (error) {
      console.error("Failed to update Top Album:", error.response?.data || error);
      toast.error("An error occurred while updating the Top Album");
    }
  };

  return (
    <Modal show={show} onHide={handleClose} centered fullscreen="sm-down">
      <Modal.Header closeButton>
        <Modal.Title>Edit Top Album</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={onSubmit}>
          <Form.Group className="mb-3">
            <Form.Label>Set Priority</Form.Label>
            <Form.Control
              type="number"
              name="priority"
              value={updatedData.priority}
              onChange={handleInputChange}
              required
              style={{ minHeight: '44px' }}
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Genres</Form.Label>
            <MultiGenreSelect
              genres={genres}
              selectedGenres={selectedGenres}
              onChange={setSelectedGenres}
              placeholder="Select Genres (Optional)"
              size="sm"
            />
          </Form.Group>

          <div className="d-flex gap-2 mt-4">
            <Button
              variant="secondary"
              onClick={handleClose}
              className="flex-grow-1"
              style={{ minHeight: '44px' }}
            >
              Cancel
            </Button>
            <Button
              variant="primary"
              type="submit"
              className="flex-grow-1"
              style={{ minHeight: '44px' }}
            >
              Save Changes
            </Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
}

export default SetTopAlbumPriorityModel;
